import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/error/404.png'


const _withScopeId = n => (_pushScopeId("data-v-086714ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-layout" }
const _hoisted_2 = { class: "page-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "404", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "当前页面不存在...", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" {\" \"} 回到首页{\" \"} ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" ; ")

export function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _hoisted_3,
          _hoisted_4,
          _createVNode(_component_router_link, {
            to: "/",
            class: "ant-btn ant-btn-primary"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        _hoisted_6
      ])
    ]),
    _hoisted_7
  ], 64))
}